import {
  AutocompleteChangeReason,
  AutocompleteChangeDetails,
} from "@mui/material";
import { SyntheticEvent } from "react";
import { Box, Chip, Typography } from "@mui/material";

interface RenderTagsProps {
  selected: string[];
  limitTags: number;
  onChange?: (
    event: SyntheticEvent,
    value: string[],
    reason: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<string[]>
  ) => void;
}

export function RenderTags({ selected, limitTags, onChange }: RenderTagsProps) {
  const chipItems = selected.slice(0, limitTags);
  const remainingItems = selected.slice(limitTags);
  const handleDelete = (option: string) => (event: SyntheticEvent) => {
    const newValue = selected.filter((item) => item !== option);
    onChange?.(event, newValue, "removeOption");
  };

  return (
    <Box sx={container}>
      <Box sx={chipContainer}>
        {chipItems.map((option, index) => (
          <Chip
            key={index}
            sx={chip}
            size="small"
            label={option}
            onDelete={handleDelete(option)}
          />
        ))}
      </Box>
      {remainingItems.length > 0 && (
        <Typography sx={remainingCount}>+{remainingItems.length}</Typography>
      )}
    </Box>
  );
}

const container = {
  gap: 1,
  display: "flex",
  overflow: "auto",
  alignItems: "center",
  "&::-webkit-scrollbar": { display: "none" },
} as const;

const chipContainer = {
  gap: 1,
  display: "flex",
  overflow: "auto",
  alignItems: "center",
  "&::-webkit-scrollbar": {
    display: "none",
  },
} as const;

const chip = {
  "& .MuiChip-label": {
    fontWeight: 400,
    overflow: "hidden",
    fontSize: "13px",
    lineHeight: "18px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
} as const;

const remainingCount = {
  noWrap: true,
  minWidth: "30px",
  color: "#1D74FF",
  textAlign: "center",
} as const;
